import * as c from '../../../../constants';

const INIT_STATE = {
  contacts: {
    customer: [],
    sale: {
      email: '',
      mobile: '',
    }
  },
  isFetchingContacts: false,
  isModalActive: false,
  isSending: false,
  isSendFailed: false,
  isSendSuccess: false,
  transactionId: '',
  contact: {
    value: '',
    type: '',
  },
};

export function EreceiptModalReducer(state = INIT_STATE, action) {
  switch (action.type) {
  case c.ERECEIPT_MODAL_RESET:
    return INIT_STATE;

  case c.ERECEIPT_MODAL_SHOW:
    return {
      ...state,
      isModalActive: true,
    };

  case c.ERECEIPT_MODAL_TOGGLE:
    return {
      ...state,
      isModalActive: !state.isModalActive,
    }

  case c.ERECEIPT_MODAL_HIDE:
    return {
      ...state,
      isModalActive: false,
    };

  case c.ERECEIPT_CONTACTS_FETCHING:
    return {
      ...state,
      isFetchingContacts: true,
    };

  case c.ERECEIPT_CONTACTS_FETCHING_DONE:
    return {
      ...state,
      isFetchingContacts: false,
      contacts: action.payload.contacts,
      transactionId: action.payload.transactionId,
    };

  case c.ERECEIPT_LINK_SENDING:
    return {
      ...state,
      isSending: true,
      contact: {
        ...action.payload,
      },
    };

  case c.ERECEIPT_LINK_SENDING_SUCCESS:
    return {
      ...state,
      isSending: false,
      isSendSuccess: true,
    };

  case c.ERECEIPT_LINK_SENDING_FAILED:
    return {
      ...state,
      isSending: false,
      isSendSuccess: false,
      isSendFailed: true,
    };

  case c.ERECEIPT_LINK_SEND_ERROR_CLEAR:
    return {
      ...state,
      isSendFailed: false,
    };

  default:
    return state;
  }
}
